<template>
  <div class="gameplan">
    <div class="normal_box">
      <div class="item_detail select-item-box select_item_red">
        <div>场勘 <i :class="themeDetail.needVerify?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
        <div>搭建 <i :class="themeDetail.needConstruct?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
        <div>临促 <i :class="themeDetail.needSpr?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
        <div>转场 <i :class="themeDetail.needTransitions?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
      </div>
      <div class="item_detail" ><span class="item_title">装饰点位  </span><span v-if="themeDetail.themeDecorates">{{getThemeDecorates(themeDetail.themeDecorates)}}</span></div>
      <div class="infoBox_cross_line_box"><div class="infoBox_cross_line"></div></div>
      <el-row v-if="themeDetail.needSpr">
        <el-col :span="12">
          <div class="item_detail"><span class="item_title">临促人员人数限制  </span><span v-if="themeDetail.pgQtyLimit||themeDetail.pgQtyLimit===0">{{themeDetail.pgQtyLimit |toThousandslsFilter()}}</span></div>
        </el-col>
        <el-col  :span="12">
          <div class="item_detail"><span class="item_title">打卡/执行信息上传方式  </span>{{themeDetail.needPerformance==null?'':(themeDetail.needPerformance===1?'督导统一上传':'临促人员自行上传”')}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="item_detail"><span class="item_title">单场投入预算  </span>{{themeDetail.investUnit |toThousandslsFilter()}}</div>
        </el-col>
        <el-col  :span="12">
          <div class="item_detail" v-if="themeDetail.needTransitions==0"><span class="item_title">每{{ getUnits('活动') }}执行活动天数 </span><span>{{themeDetail.perExecDays  |toThousandslsFilter()}} 天</span></div>
          <div class="item_detail" v-else><span class="item_title">道具数量设置 </span><span v-if="themeDetail.itemQuantity||themeDetail.itemQuantity===0">{{themeDetail.itemQuantity  |toThousandslsFilter()}}</span></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="item_detail"><span class="item_title">提报售点要求  </span>{{ pocRelateTypeDesc }}</div>
        </el-col>
        <el-col  :span="12">
          <div class="item_detail" v-if="themeDetail.pocCountMin>1"><span class="item_title">最少关联售点数  </span><span>{{themeDetail.pocCountMin  |toThousandslsFilter() }}</span></div>
        </el-col>
      </el-row>
      <!-- <div class="item_detail" v-if="themeDetail.themeDecorates"><span class="item_title">装饰点位  </span><span>{{getThemeDecorates(themeDetail.themeDecorates)}}</span></div>
      <div class="item_detail"><span class="item_title">临促人员人数限制  </span>{{themeDetail.pgQtyLimit}}</div>
      <div class="infoBox_cross_line_box"><div class="infoBox_cross_line"></div></div>
      <div class="item_detail"><span class="item_title">提报售点要求  </span>{{ pocRelateTypeDesc }}</div>
      <div class="item_detail" v-if="themeDetail.pocCountMin>1"><span class="item_title">最少关联售点数  </span><span>{{themeDetail.pocCountMin}}</span></div>
      <div class="item_detail"><span class="item_title">单场投入预算  </span>￥ {{themeDetail.investUnit}}</div>
      <div class="item_detail" v-if="themeDetail.needTransitions==0"><span class="item_title">每{{ getUnits('活动') }}执行活动天数 </span><span>{{themeDetail.perExecDays}} 天</span></div>
      <div class="item_detail" v-else><span class="item_title">道具数量设置 </span><span>{{themeDetail.itemQuantity}}</span></div> -->
      <div class="item_detail">
        <span class="item_title">
          <div>额度分配信息</div>
          <!-- <div class="edit-btn" v-if="(isBU&&subAssignList.length>0)||(isHQ&&hasQty&&item.isShow&&isShowEdit)" @click="showEditDialog()">编辑</div> -->
        </span>
        <el-form :inline="true" ref="editFormRef" :rules="editRules" :model="params" label-position="left" label-width="176px">
        <el-form-item class="input-width-sp" prop="itemQuantity" ref="itemQuantityRef">
          <el-select v-model="assignList" multiple collapse-tags clearable placeholder="请选择">
            <el-option
              v-for="item in getAssignList"
              :key="item.orgCode"
              :label="getName(item.orgName)"
              :value="item.orgCode">
            </el-option>
          </el-select>
          <span v-if="themeDetail.needTransitions===0">总{{getUnits()}}：{{saveInfo.curAssignList[0].assignQty || 0}} &ensp; &ensp;</span>
          <span>总执行天数： {{(Number(saveInfo.curAssignList[0].assignQty)*Number(themeDetail.perExecDays)) |toThousandslsFilter()}}&ensp; &ensp;</span>
          已分配：{{getAllAssignQty |toThousandslsFilter()}} &ensp;
          <!-- <span>待分配：{{ ( Number(saveInfo.curAssignList[0].assignQty) - getAssignQty()) || 0}}</span> -->
        </el-form-item>
        <div class="config-detail-bu">
          <div class="assign-box" >
            <el-form v-for="item of assignInfoList" :model="item" :key="item.orgName" ref="assignFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
              <el-form-item :label="getName(item.orgName)" prop="assignQty" v-if="assignList.indexOf(item.orgCode)!==-1">
                  <el-input type="number" oninput="value=value.replace(/[^\d]/g,'')" :min="0"  class="item" v-model="item.assignQty" placeholder="请输入分配额度"></el-input>
                  <div class="font-red"> 执行天数：{{ getTotalCountQty(item.assignQty) |toThousandslsFilter()}} </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-form>
        <!-- <div>
          <div v-if="isRegion" class="item_assign">
            <div v-for="(session,index) of curAssignInfo" :key="index">
              <div class="item_assign_first_box" v-if="(session.subAssignList&&session.subAssignList.length>0)">
                <div class="item_assign_first" v-for="item of session.subAssignList" :key="item.areaCode">{{getName(item.areaName)}}：{{item.assignQty}} {{ getUnits() }}</div>
              </div>
              <div class="item_assign_first_box" v-else>
                <div class="item_assign_first">{{getName(session.regionName)}}：{{session.assignQty}} {{ getUnits() }}</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <el-dialog
      :visible.sync="showConfirmDialog" :before-close="handleDialogClose" width="850px" >
      <div class="assign-region-box" v-if="inputData.length>0">
        <div v-if="(curAssignInfo&&curAssignInfo.length>0)">
          <div v-for="(session,index) of curAssignInfo" :key="session.displayDate">
            <div class="session-info-box">
              <!-- <div class="session-time">{{session.displayDate}}</div> -->
              <div class="assign-number">待配置{{ getUnits() }}数：{{getResult(index)}}</div>
            </div>
            <div class="assign-region-item-box">
              <ConfigDetailAssignUpdate :subAssignListInfo="session.subAssignList" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" :units="getUnits()"/>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(session,index) of subAssignList" :key="session.displayDate">
            <div class="session-info-box">
              <!-- <div class="session-time">{{ session[0].assignStartTime | parseTime("{y}-{m}-{d}") }} 至 {{ session[0].assignEndTime | parseTime("{y}-{m}-{d}") }}</div> -->
              <div class="assign-number">待配置{{ getUnits() }}数：{{getResult(index)}}</div>
            </div>
            <div class="assign-region-item-box">
              <ConfigDetailAssignUpdate :subAssignListInfo="session" :needTransitions="needTransitions" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" :units="getUnits()" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="assign-region-box" v-if="inputData.length>0">
        <div v-for="(session,index) of subAssignList" :key="session.displayDate">
          <div class="session-info-box">
            <div class="session-time">{{ session[0].assignStartTime | parseTime("{y}-{m}-{d}") }} 至 {{ session[0].assignEndTime | parseTime("{y}-{m}-{d}") }}</div>
            <div class="assign-number">待配置场数：{{getResult(index)}}</div>
          </div>
          <div class="assign-region-item-box">
            <ConfigDetailAssignUpdate :subAssignListInfo="session" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" />
          </div>
        </div>
      </div> -->
      <div class="warning" v-show="showError1">{{isHQ?`待配置${getUnits()}数需为0`:`额度分配不可小于已提报数，且待配置${getUnits()}数不可小于0`}}</div>
      <div class="warning" v-show="showError2">{{isHQ?`额度分配必填，且待配置${getUnits()}数需大于0`:`额度分配必填，且待配置${getUnits()}数需大于0`}}</div>
      <div slot="footer" class="dialog-footer">
        <div v-if="(showError2||showError1)" :class="['submit_item_btn','submit_item_btn_disabled']">确认修改</div>
        <div v-else class="submit_item_btn" @click="submit()">确认修改</div>
      </div>
    </el-dialog>

        <!-- <el-table :data="bu.regionAssignList||[bu]" v-for="(bu,i) of subAssignList" :key="bu.bucode" border :show-header="false" :span-method="objectSpanMethod" :cell-style="{'text-align':'center'}">
          <el-table-column align="center" width="150px" >
            <template slot-scope="{  }">
              <div>{{getName(bu.buName)}}：{{bu.assignQty}}场
                <div v-if="subAssignList[i].regionAssignList">(已提报：<span class="submitCountQty">{{bu.submitCountQty}}场</span>)</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="280">
            <template slot-scope="{ row, }">
              <div class="item_assign_second" v-if="subAssignList[i].regionAssignList">
                {{getName(row.regionName)}}：{{row.assignQty}}场 (已提报：<span class="submitCountQty">{{row.submitCountQty}}场</span>)
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="320">
            <template slot-scope="{ row }">
              <div class="item_assign_second" v-if="row.areaAssignList">
                <div class="item_assign_second_item" v-for="(area,areaI) of row.areaAssignList" :key="area.areaCode">
                  <span v-if="areaI!==0">、</span>
                  {{getName(area.areaName)}}(已提报：<span class="submitCountQty">{{area.submitCountQty}}场</span>)
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table> -->
    </div>
  </div>

</template>

<script>
import gameplanApi from "@/api/gameplan";
import { mapGetters,mapState } from 'vuex'
import ConfigDetailAssignUpdate from './config-detail-assign-update.vue'
export default {
  components:{
    ConfigDetailAssignUpdate
  },
  props: {
    configInfo:{ type: Object, default: () => { } },
    itemKey:{ type: String, default: '' },
    themeChannelCode:{ type: String, default: '' }
  },
  data() {
    var validatePocCountMin = (rule, value, callback) => {
      if(Number(value)<1){
        return callback(new Error('最小售点数需大于等于1'));
      }else {
        callback()
      }
    };
    return {
      assignList:[],
      assignInfoList:[],
      themeConfig:{},
      saveInfo:{},
      params: {
        needVerify: 1,
        needConstruct: 1,
        needSpr: 1,
        needSupervisor: 1,
        needPerformance:1,
        themeDecorateCodes: [],
        pocCountMin: '',
        pocRelateType:2,
        pgQtyLimit:'',
        investUnit:'',
        needTransitions:1,
        itemQuantity:'',
        perExecDays:''
      },
      themeDetail:{},
      editRules: {
        itemQuantity: [{ required: true, message: '请设置道具数量', trigger: 'blur' }],
        assignQty:[{required: true, message: '请输入额度配置', trigger: 'blur' }],
      },
      mandatoryDecorates: [],
      themeLevelsInfo: {},
      subAssignItem:{},
      subAssignList:[],
      assignBu:[],
      showDecorates:[],
      isSave:false,
      saveConfig:{},
      themeStyles:{},
      saveSubAssignList:[],
      employeeLevel:'',
      showError:false,
      btnType:'',
      //cityPoolList:[],
      showSaveAssignList:false,
      showConfirmDialog:false,
      inputData:[],
      showError1:false,
      showError2:false,
    }
  },
  computed:{
     ...mapGetters(['userInfo']),
     ...mapState({
      buList: state => state.gameplan.buList,
      regionList: state => state.gameplan.regionList,
      areaList: state => state.gameplan.areaList,
    }),
     pocRelateTypeDesc () {
      if (this.themeConfig.pocRelateType === 0) {
        return '当前活动形式无需执行售点'
      } else if (this.themeConfig.pocRelateType === 1) {
        return '当前活动形式需要单售点执行'
      } else if (this.themeConfig.pocRelateType === 2) {
        return '当前活动形式需要多售点执行'
      } else {
        return ''
      }
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getAssignName(){
      if(this.isHQ) return 'BU额度配置'
      else if(this.isBU) return '销售大区额度配置'
      else return '销售大区额度配置'
    },
    getAssignList(){
      if(this.isHQ) return this.buList
      else if(this.isBU) return this.regionList
      else return this.areaList
    },
    getAllAssignQty(){
       let assignQty = this.assignInfoList.reduce((pre,item)=>{
        return pre + Number(item.assignQty)
      },0)
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return assignQty || 0
    }
  },
  watch:{
    assignInfoList:{
      handler:function(cur){
        this.submitData()
      },
      deep:true
    },
    assignList(){
      this.submitData()
    },
    subAssignList:{
      handler:function(cur){
        this.getAssignQty()
      },
      deep:true,
      immediate:true
    }
  },
  created() {
    this.employeeLevel = this.userInfo.employeeLevel
    this.themeConfig =  this.configInfo.themeConfig
    this.saveInfo = this.configInfo.saveInfo || {}
    this.themeDetail = this.saveInfo.themeDetail || {}
    this.subAssignList = this.saveInfo.subAssignList || []
    this.assignInfoList =  this.getAssignList.map(assignItem=>{
      let data = {
        orgName:assignItem.orgName,
        orgCode:assignItem.orgCode,
        assignQty:'',
        srcAssignId:this.saveInfo.curAssignList[0].assignId
      }
      return data
    })
    this.showDecorates = this.themeConfig.showDecorates || []
    if(Object.keys(this.saveInfo).length>0){
      if(Object.keys(this.saveInfo.themeDetail).length!==0){
        for(let key in this.params){
          this.params[key] = this.saveInfo.themeDetail[key]
        }
      }
      let key
      if(this.isHQ) key ='buCode'
      else if(this.isBU) key='regionCode'
      else if(this.isRegion) key='areaCode'
      if(this.saveInfo.subAssignList){
        this.assignList = this.saveInfo.subAssignList.map(item=>{
          return item[key]
        })
        this.assignInfoList.forEach(assignItem=>{
          this.saveInfo.subAssignList.forEach(savedItem=>{
            if(savedItem[key]===assignItem.orgCode){
              assignItem.assignQty = savedItem.assignQty
            }
          })
        })
      }
    }
  },
  mounted(){
  },
  methods: {
    getAssignQty(){
      let assignQty
      assignQty = this.subAssignList.reduce((pre,item)=>{
        return pre + Number(item.assignQty)
      },0)
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return assignQty
    },
    showEditDialog(){
      this.showError1 = false
      this.showError2 = false
      this.inputData = []
      let count = 0
      if(this.isBU){
        this.subAssignList.map(item=>{
          let data = {
            assignQty:item.assignQty,
            regionCode:item.regionCode
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }else if(this.isHQ){
        this.subAssignList.map(item=>{
          let data = {
            assignQty:item.assignQty,
            buCode:item.buCode,
            assignStatus:item.assignStatus,
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }
      this.total = this.subAssignList.assignQty || count
      this.count = count
      this.remain = this.subAssignList.assignQty - count || 0
      this.showConfirmDialog = true
    },
    handleInputAssign(index){
      this.showError1 = false
      this.showError2 = false
      this.inputData[index].assignQty=this.inputData[index].assignQty||0
      let sum = this.inputData.reduce((pre,cur)=>{
        return pre+=Number(cur.assignQty)
      },0)
      this.remain = this.total - sum
      for(let i=0;i<this.inputData.length;i++){
        if(this.inputData[i].assignQty<this.getRegionQty(this.subAssignList[i])||this.inputData[i].assignQty<this.subAssignList[i].submitCountQty){
          this.showError1 = true
          return
        }
      }
      if(this.isHQ){
        //console.log(this.inputData[index].assignQty);
        //console.log(this.getRegionQty(this.subAssignList[index]));
        if(this.inputData[index].assignQty<this.getRegionQty(this.subAssignList[index])||this.remain<0){
          this.showError1 = true
          return
        }
        this.showError2 = false
      }else {
        if(this.inputData[index].assignQty<this.subAssignList[index].submitCountQty||this.remain<0){
          this.showError1 = true
          return
        }
        this.showError1 = false
        if(this.remain < 0){
          this.showError2 = true
          return
        }
        this.showError2 = false
      }
    },
    handleDialogClose(){
      this.inputData = []
      this.showConfirmDialog=false
    },
    getRegionQty(assignItem){
      let result = 0
      if(assignItem.regionAssignList){
        for(let item of assignItem.regionAssignList){
          result+=Number(item.assignQty)
        }
      }
      return result
    },
    submitData(){
      let subAssignList = this.assignInfoList.filter(assignItem=>{
          //console.log(this.assignList.indexOf(assignItem.orgCode)!==-1);
        return this.assignList.indexOf(assignItem.orgCode)!==-1
      })
      // let themeDetail=this.params
      // this.configInfo.themeStyleCode?themeDetail.themeStyleCode = this.configInfo.themeStyleCode:''
      // this.configInfo.themeLevelCode?themeDetail.themeLevelCode = this.configInfo.themeLevelCode:''
      // this.themeConfig.pocRelateType !== 2 ? themeDetail.pocCountMin = this.themeConfig.pocRelateType :''
      // themeDetail.themeChannelCode = this.themeChannelCode
      let themeDetail=this.configInfo.saveInfo.themeDetail
      let isValid = true
      if(subAssignList.length===0) isValid = false
      subAssignList.forEach(item=>{
        if(item.assignQty===''){
          isValid = false
        }
      })
      let data = {
        subAssignList,
        themeDetail,
        isValid
      }
      this.$emit('submitDetail',data,this.itemKey)
    },
    getUnits(){
      let key = this.themeConfig.pocRelateType+''
      let units = '街区'
      switch (key) {
        case '0':
          units = '活动地点'
          break;
          case '1':
          units = '售点'
          break;
        default:
        units = '街区'
          break;
      }
      return units
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if(this.isHQ){
        if (columnIndex === 0 ) {
          if(rowIndex===0){
            return {
              rowspan: (this.subAssignList[row.index]&&this.subAssignList[row.index].regionAssignList&&this.subAssignList[row.index].regionAssignList.length) || 1,
              colspan: 1
            }
          }else if(rowIndex!=0){
            return {
              rowspan:0,
              colspan:0
            }
          }
        }
      }else if(this.isBU){
        if (columnIndex === 0) {
          if (rowIndex % this.subAssignList.length === 0) {
            return {
              rowspan: this.subAssignList.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    getTotalCountQty(assignQty){
      if(assignQty){
        return `${this.params.needTransitions?assignQty:assignQty*this.params.perExecDays}`
      }
    },
    validateAssign(){
      if((this.saveInfo.curAssignList[0].assignQty - this.getAllAssignQty)<0) {
        this.$message.error(`"${this.saveInfo.themeDetail.themeStyleName+(this.saveInfo.themeDetail.themeLevelName?'-'+this.saveInfo.themeDetail.themeLevelName:'')}"额度超出可分配数量！`)
        return false
      }else return true
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    getThemeDecorates(themeDecoratesList){
      let res = []
      for(let item of themeDecoratesList){
        res.push(item.decorateName)
      }
      return res.join('、')
    }
  }
}
</script>

<style lang="scss" scoped>
.font-red{
  color: rgb(226, 0, 0);
}
  .item_detail{
    //width: 900px;
    font-size: 15px;
    margin: 0px 15px 30px 15px;
    display: flex;
    .edit-btn{
      cursor: pointer;
      margin-top: 5px;
      font-size: 12px;
      width: 50px;
      text-align: center;
      padding: 8px 5px;
      color: rgb(37, 158, 228);
      border: 1px solid rgb(37, 158, 228);
      border-radius: 4px;
      line-height: 12px;
    }
  }
  .item_title{
    display: inline-block;
    min-width: 165px !important;
    font-weight: 700;
    color: black;
    text-align: right;
    margin-right: 20px;
  }
  .infoBox_cross_line_box {
  margin: -10px 0px 30px 15px;
  font-weight: 600;
  color: rgb(182, 182, 182);
  .infoBox_cross_line{
    width:1000px;
    height: 1px;
    background-color: rgb(238, 238, 238);
    margin: -9px 0 0 0px;
  }
}
.select-item-box{
  margin-left: 100px;
  width: 400px;
  display: flex;
  justify-content: space-evenly;
}
.color-green{
  color: rgb(42, 219, 33);
}
.color-red{
  color: rgb(219, 93, 33)
}
.item_assign{
  //display: flex;
  margin:0 40px 0px 0;
  // border: 1px solid grey;
}
.item_assign_first{
  margin:0 30px 30px 0;
}
.normal_box{
  padding-left: 30px;
}
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom:8px;

  .el-form-item__label {
    color: black;
    font-weight: 600;
    margin-left:3px;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}
::v-deep .el-input__inner {
  width: 200px !important;
}
::v-deep .input-width-sp .el-input__inner {
  width: 155px;
}
::v-deep .el-select {
  margin: 0 20px 20px 0;
}
.el-form-item{
  width: 100%;
}
.sp-el-form{
  width: 75%;
  position: relative;
  left: 180px;
  margin-top: -65px;
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-form-item__error{
  width: 150px;
}


::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    margin-left: -10px;
}

// ::v-deep .el-select__tags {
//   display: flex;
//   flex-wrap: nowrap !important;
//   height: 35px;
//   overflow: hidden;
// }

// 额度分配
::v-deep .assign-box .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
::v-deep .assign-box .el-form-item {
  display: flex;
  flex-direction: column;
}
.assign-box{
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
// 装饰点位 默认选中 灰色样式
::v-deep .sp .el-checkbox__input.is-checked .el-checkbox__inner,.sp .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #b5b5b5 !important;
    border-color: #b5b5b5 !important;
}
::v-deep .sp .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #ffffff !important;
    color: #606266 !important;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266 !important;
}
.el-checkbox{
  margin-right: 20px;
}
.decorate-style{
  width: 750px;
  display:flex;
  flex-wrap: wrap;
}
</style>
